import { GraduationCap, Building2 } from "lucide-react";
import { Badge } from "@/components/ui/others/Badges";
import { useEduChildModuleData } from "@/module/education/helpers/useEduChildModuleData";

export function ChildTrigger({ child }: any) {
  const isActive = !child?.isFroze;
  const { universityName, courseName } = useEduChildModuleData(child);
  const hasCourseInfo = universityName || courseName;

  return (
    <div className="flex items-center gap-2.5 w-full">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-[14px] font-semibold text-[#1e302a] tracking-[-0.28px] truncate">
            {child?.name || "--"}
          </p>
          <Badge
            className={`text-[11px] font-medium px-2 py-0 rounded-full shrink-0 ${
              isActive
                ? "bg-[#dcf5e9] text-[#0b4627]"
                : "bg-[#e8eaed] text-[#555]"
            }`}
          >
            {isActive ? "Active" : "Paused"}
          </Badge>
        </div>

        {hasCourseInfo ? (
          <div className="flex items-center gap-1.5 mt-1">
            {universityName && (
              <span className="inline-flex items-center gap-1 text-[12px] text-[#697571]">
                <Building2 className="size-3 shrink-0" />
                <span className="truncate max-w-[140px]">{universityName}</span>
              </span>
            )}
            {universityName && courseName && (
              <span className="text-[#c5c9c7]">·</span>
            )}
            {courseName && (
              <span className="inline-flex items-center gap-1 text-[12px] text-[#697571]">
                <GraduationCap className="size-3 shrink-0" />
                <span className="truncate max-w-[140px]">{courseName}</span>
              </span>
            )}
          </div>
        ) : (
          <p className="text-[11px] text-[#b3b8b5] mt-0.5">
            No course attached
          </p>
        )}
      </div>
    </div>
  );
}
